
// Widget Scripts
import registerNowButton from './js/widgets/registerNowButton';
import registerSlideShow from './js/widgets/registerSlideShow.js';

import mainFeatureSlide from './js/widgets/mainFeatureSlide';

import seoBlockFeature from './js/widgets/seoBlockFeature';
import secondFeatureBg from './js/widgets/secondFeatureBg';

import featureCards from './js/widgets/featureCards';
import featureCardsIcons from './js/widgets/featureCardsIcons';


import contentBlockModule from './js/widgets/contentBlockModule';
import managedPictures from './js/widgets/managedPictures';

import sponsors from './js/widgets/sponsors';




import AOS from 'aos';
import 'aos/dist/aos.css';
// Custom Theme Scripts
import './js/localjs.js';
import './js/SiteInfoBanner.js';


// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    mainFeatureSlide();
    registerSlideShow();
    seoBlockFeature()
    secondFeatureBg()
    featureCards()

    setTimeout(() => {
      featureCardsIcons()
    }, 800);


    contentBlockModule()
    managedPictures()
    sponsors()


  });
}

$(document).ready(function () {
  registerNowButton()
  setTimeout(() => {
    AOS.init({
      anchorPlacement: 'bottom-bottom',
      animatedClassName: 'aos-animate',
      initClassName: 'aos-init',
    });
  }, 2000)

})



